module.exports = __webpack_public_path__ + "media/images/training-failed-evaluation-score-modal-bbef71df53673d437b98d001e60acbc0.svg";